import React, { useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Divider, Box, Button, Menu, MenuItem } from "@mui/material";
import FileUploadDialog from "./FileUploadDialog";
import { format } from 'date-fns';
import LinkAttachDialog from "./LinkAttachDialog";
import AttachmentItemActions from "./AttachmentItemActions";
import ShowAttachment from './ShowAttachment';

export default function Attachments({ data, fetchAttachments, entity }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false); // State for the dialog
    const [linkDialogOpen, setLinkDialogOpen] = useState(false);
    const [attachment, setAttachment] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleUploadClick = () => {
        setUploadDialogOpen(true); // Open the dialog
        handleClose(); // Close the menu
    };

    const handleLinkClick = (attachmentItem) => {
        setAttachment(attachmentItem);
        setLinkDialogOpen(true);
        handleClose();
    }

    const handleDialogClose = () => {
        setUploadDialogOpen(false); // Close the dialog
        fetchAttachments();
    };

    const handleLinkDialogClose = () => {
        setLinkDialogOpen(false);
    }

    return (

        <Paper elevation={0} sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                <h4>Attachments</h4>
                <Box sx={{ display: 'flex', gap: 1 }}>

                    <Button variant="outlined"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>Attach</Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handleUploadClick}>Upload File</MenuItem>
                        <MenuItem onClick={handleLinkClick}>Link (URL)</MenuItem>
                    </Menu>

                    {/* <Button variant="outlined">Actions</Button> */}

                </Box>
            </Box>
            <Divider />
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell width={150}>File Name</TableCell>
                            <TableCell align="right">Attached By</TableCell>
                            <TableCell align="right">Date Added</TableCell>
                            <TableCell align="right">Size</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                <ShowAttachment attachmentUri={row.uri} fileName={row.fileName} />
                                </TableCell>
                                <TableCell align="right">{row.createdBy}</TableCell>
                                <TableCell align="right">{format(row.createdAt, 'MMMM do yyyy, h:mm:ss a')}</TableCell>
                                <TableCell align="right">{row.fileSize / 1024} kb</TableCell>
                                <TableCell align="right">
                                    <AttachmentItemActions attachment={row} handleLinkClick={handleLinkClick} fetchAttachments={fetchAttachments} entity={entity} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <FileUploadDialog open={uploadDialogOpen} onClose={handleDialogClose} fetchAttachments={fetchAttachments} entity={entity} />
            <LinkAttachDialog open={linkDialogOpen} onClose={handleLinkDialogClose} fetchAttachments={fetchAttachments} attachment={attachment} entity={entity} />
        </Paper>
    );
}